import { forwardRef } from 'react';

import Text from '~/common/componentMapper/Text';
import ChakraTextarea from '~/common/componentMapper/Textarea';

type TextAreaProps = React.ComponentProps<typeof ChakraTextarea> & {
  maxLength?: number;
  sx?: any;
  placeholder?: string;
  value?: string;
  showMaxLength?: boolean;
  defaultValue?: string;
  resize?: 'both' | 'vertical' | 'none' | 'horizontal' | 'initial' | 'inherit';
};

const TextArea = forwardRef<any, TextAreaProps>(
  (
    { maxLength, sx, value, showMaxLength, resize, defaultValue, ...props },
    ref,
  ) => {
    const currentTextLength = value?.split('').length;
    return (
      <>
        <ChakraTextarea
          {...props}
          value={value}
          defaultValue={defaultValue}
          sx={sx}
          maxLength={maxLength}
          resize={resize}
          ref={ref}
        />
        {showMaxLength && (
          <Text align={'right'} fontWeight={'bold'}>
            {currentTextLength} / {maxLength}
          </Text>
        )}
      </>
    );
  },
);

TextArea.displayName = 'TextArea';
export default TextArea;
